import React from 'react';
//import Nailova from '../components/Funcity'; // adjust path as necessary
import Funcity from '../components/Funcity';

const FuncityPresentation = () => {
  return (
    <>
      <Funcity />
    </>
  );
};

export default FuncityPresentation;
